"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncApi = exports.SyncApiFactory = exports.SyncApiFp = exports.SyncApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SyncApi - axios parameter creator
 * @export
 */
const SyncApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get sync backup expansion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncBackupExpansion: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sync/backup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get sync folder size
         * @param {string} [selectedFolders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncFolderSize: (selectedFolders, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sync/size`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (selectedFolders !== undefined) {
                localVarQueryParameter['selectedFolders'] = selectedFolders;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get sync initial document tree
         * @param {ModelString} [lastId]
         * @param {ModelString} [limit]
         * @param {string} [rootFolderIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncInitialDocumentTree: (lastId, limit, rootFolderIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sync/initial-documents-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (lastId !== undefined) {
                localVarQueryParameter['lastId'] = lastId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (rootFolderIds !== undefined) {
                localVarQueryParameter['rootFolderIds'] = rootFolderIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get sync initial folder tree
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [selectedFolders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncInitialFolderTree: (filter, selectedFolders, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sync/initial-folder-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (selectedFolders !== undefined) {
                localVarQueryParameter['selectedFolders'] = selectedFolders;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SyncApiAxiosParamCreator = SyncApiAxiosParamCreator;
/**
 * SyncApi - functional programming interface
 * @export
 */
const SyncApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SyncApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get sync backup expansion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncBackupExpansion(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSyncBackupExpansion(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get sync folder size
         * @param {string} [selectedFolders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncFolderSize(selectedFolders, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSyncFolderSize(selectedFolders, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get sync initial document tree
         * @param {ModelString} [lastId]
         * @param {ModelString} [limit]
         * @param {string} [rootFolderIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncInitialDocumentTree(lastId, limit, rootFolderIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSyncInitialDocumentTree(lastId, limit, rootFolderIds, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get sync initial folder tree
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [selectedFolders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncInitialFolderTree(filter, selectedFolders, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSyncInitialFolderTree(filter, selectedFolders, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SyncApiFp = SyncApiFp;
/**
 * SyncApi - factory interface
 * @export
 */
const SyncApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SyncApiFp)(configuration);
    return {
        /**
         *
         * @summary Get sync backup expansion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncBackupExpansion(options) {
            return localVarFp.getSyncBackupExpansion(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get sync folder size
         * @param {string} [selectedFolders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncFolderSize(selectedFolders, options) {
            return localVarFp.getSyncFolderSize(selectedFolders, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get sync initial document tree
         * @param {ModelString} [lastId]
         * @param {ModelString} [limit]
         * @param {string} [rootFolderIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncInitialDocumentTree(lastId, limit, rootFolderIds, options) {
            return localVarFp.getSyncInitialDocumentTree(lastId, limit, rootFolderIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get sync initial folder tree
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [selectedFolders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncInitialFolderTree(filter, selectedFolders, options) {
            return localVarFp.getSyncInitialFolderTree(filter, selectedFolders, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SyncApiFactory = SyncApiFactory;
/**
 * SyncApi - object-oriented interface
 * @export
 * @class SyncApi
 * @extends {BaseAPI}
 */
class SyncApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get sync backup expansion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    getSyncBackupExpansion(options) {
        return (0, exports.SyncApiFp)(this.configuration).getSyncBackupExpansion(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get sync folder size
     * @param {string} [selectedFolders]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    getSyncFolderSize(selectedFolders, options) {
        return (0, exports.SyncApiFp)(this.configuration).getSyncFolderSize(selectedFolders, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get sync initial document tree
     * @param {ModelString} [lastId]
     * @param {ModelString} [limit]
     * @param {string} [rootFolderIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    getSyncInitialDocumentTree(lastId, limit, rootFolderIds, options) {
        return (0, exports.SyncApiFp)(this.configuration).getSyncInitialDocumentTree(lastId, limit, rootFolderIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get sync initial folder tree
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {string} [selectedFolders]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    getSyncInitialFolderTree(filter, selectedFolders, options) {
        return (0, exports.SyncApiFp)(this.configuration).getSyncInitialFolderTree(filter, selectedFolders, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SyncApi = SyncApi;
